module.exports = __webpack_public_path__ + "assets/fonts/fa992b8053efec6c81baf8229ff2df99.woff";